import React, { useState, useEffect, useRef } from 'react';
import { DataGridPro, GridToolbarContainer, GridToolbarExport, GridToolbarQuickFilter, GridActionsCellItem, GridColumnMenu, useGridApiRef, GridFooter, GRID_CHECKBOX_SELECTION_COL_DEF } from '@mui/x-data-grid-pro';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Modal from 'react-bootstrap/Modal';
import { FaChevronDown } from 'react-icons/fa';
import { VscFolderActive } from 'react-icons/vsc';
import { ToastContainer } from 'react-toastify';
import { ListsModal } from '../../contexts';
import AddEvent from '../../components/Modals/AddEvent';
import SendTxt from '../../components/Modals/SendTxt';
import SendEmail from '../../components/Modals/SendEmail';
// import Toolbar from '../../containers/Grid/Toolbar';
import LogComms from '../../components/Modals/LogComms';
import SendMassEmail from '../../components/Modals/SendMassEmail';
import EmailIcon from '@mui/icons-material/Email';
import TextsmsIcon from '@mui/icons-material/Textsms';
import ScheduleIcon from '@mui/icons-material/Schedule';
import CallIcon from '@mui/icons-material/Call';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { formatPhone, launchPhoneBurner, singleSelectQuickFilter } from '../../common/utils';
import _ from 'lodash';
import { update } from '../../common/api';
import Select from 'react-select';



import "react-toastify/dist/ReactToastify.css";
import '../../containers/Dashboard/dashboard.css';
import { RiWalkFill } from 'react-icons/ri';

function useQuery() {
    return new URLSearchParams( useLocation().search );
}

const toolbar = ( { selectedRows, handleModal, hasTxting, hasPhoneBurner, canExport } ) => {
    return(
        <GridToolbarContainer>
            <Container fluid className='p-0'>
                <Row className='p-0 align-items-center'>
                    <Col>
                        <Row className='text-start align-items-center'>
                            <Col xs='auto' className='pe-0'>
                                <GridFooter className='tf-fake-footer' />
                            </Col>
                            <Col xs='auto'>
                                { 
                                    selectedRows.length > 0 &&
                                    <Row style={ { borderLeft: '1px solid #CCC' } }>
                                        <Col xs='auto' className='pe-2'>Take Action...</Col>
                                        <Col xs='auto' className='ps-0'>
                                            <DropdownButton size='sm' title={<FaChevronDown />} className='tf-button-transparent tf-hide-arrow'>
                                                <Dropdown.Item onClick={ () => handleModal( 'email-mass' ) }>Send Mass Email</Dropdown.Item>
                                                {
                                                    hasTxting ? (
                                                        <Dropdown.Item onClick={ () => handleModal( 'sms-mass' ) }>Send Mass Txt</Dropdown.Item>
                                                    ) : (
                                                        null
                                                    )
                                                }
                                                <Dropdown.Divider />
                                                {
                                                    hasPhoneBurner ? (
                                                        <Dropdown.Item onClick={ () => handleModal( 'phoneburner' ) }>Launch PhoneBurner</Dropdown.Item>
                                                    ) : (
                                                        null
                                                    )
                                                }
                                                <Dropdown.Item onClick={ () => handleModal( 'list' ) }>Add to a List</Dropdown.Item>
                                                <Dropdown.Item onClick={ () => handleModal( 'event' ) }>Add to an Event</Dropdown.Item>
                                            </DropdownButton>
                                        </Col>
                                    </Row>
                                }
                            </Col>
                        </Row>
                    </Col>
                    <Col xs='auto' className='text-right'>
                        <GridToolbarQuickFilter />
                    </Col>
                    {
                        ( canExport ) ? (
                            <Col xs='auto' className='pe-3 text-right'>
                                <GridToolbarExport />
                            </Col>
                        ) : (
                            null
                        )
                    }
                </Row>
            </Container>
        </GridToolbarContainer>
    )
}

const customColumnMenu = ( props ) => {
    return (
        <GridColumnMenu
            { ...props }
            slots={ {
                columnMenuColumnsItem: null,
                columnMenuPinningItem: null
            } }
        />
    );
}

const Users = ( { orgId, aid, uid, user, users, viewing, grids, canExport, stack, setDatagridOrder, setDatagridWidth } ) => {
    const [ gridHeight, setGridHeight ] = useState( 0 );
    const [ containerBuffer, setContainerBuffer ] = useState( 125 );
    
    const [show, setShow] = useState(false);
    const closeModal = () => setShow(false);
    const openModal = () => setShow(true);
    const [ modal, setModal ] = useState();
    const [ loading, setLoading ] = useState( true );
    const [ cols, setCols ] = useState( [] );
    const [ gridReady, setGridReady ] = useState( false );
    const [ filterModel, setFilterModel ] = useState( { items: [] } );
    const [ q, setQ ] = useState( '' );
    const [ classLogic, setClassLogic ] = useState( '' );
    const [ rowModesModel, setRowModesModel ] = useState( {} );
    const [ hasUnsavedRows, setHasUnsavedRows ] = useState( false );
    const [ isSaving, setIsSaving ] = useState( false );
    const [ singleSaveId, setSingleSaveId ] = useState( '' );
    const [ isDiscarding, setIsDiscarding ] = useState( false );
    const [ usingFilter, setUsingFilter ] = useState( false );
    const [ filterName, setFilterName ] = useState( '' );
    const [ hasPhoneBurner, setHasPhoneBurner ] = useState( false );
    const [ hasTxting, setHasTxting ] = useState( false );
    const [ uList, setUsers ] = useState( [] );

    const containerRef = useRef();
    const titleRef = useRef();
    const modesRef = useRef();
    modesRef.current = rowModesModel;

    const gridRef = useGridApiRef();

    const location = useLocation();

    const query = useQuery();
    
    const handleColumnWidthChange = async ( { colDef, width } ) => {
        const datagrid = 'users';

        let newWidths = {};
        gridRef.current.getAllColumns().forEach( col => {
            if ( ![ '__check__', 'actions' ].includes( col.field ) ) {
                newWidths[col.field] = col.width;
            }
        } );
        setDatagridWidth( { grid: datagrid, values: newWidths, fn: filterName } );
        await update( orgId, aid, uid, 'datagrid-width', uid, {
            grid: datagrid,
            values: newWidths,
            fn: filterName
        } );
    }

    const handleColumnOrderChange = async ( params ) => {
        const datagrid = 'users';

        const newOrder = [];
        gridRef.current.getAllColumns().forEach( col => {
            if ( ![ '__check__', 'actions' ].includes( col.field ) ) {
                newOrder.push( col.field );
            }
        } );
        setDatagridOrder( { grid: datagrid, values: newOrder, fn: filterName } );
        await update( orgId, aid, uid, 'datagrid-order', uid, {
            grid: datagrid,
            values: newOrder,
            fn: filterName
        } );
    }

    const gridHelpers = {
        valueGetter: {
            date: ( { value } ) => {
                let d;
                if ( value ) {
                    d = new Date( value );
                    if ( !value.match( 'T' ) ) {
                        d.setDate( d.getDate() + 1 );
                    }
                }
                return ( d ) ? d : null;
            },
            appUrl: ( { id } ) => {
                let url;
                const u = users[id];
                if ( u ) {
                    if ( u.links && u.links.app ) {
                        url = u.links.app;
                    }
                }
                return url;
            },
            webUrl: ( { id } ) => {
                let url;
                const u = users[id];
                if ( u ) {
                    if ( u.links && u.links.web && u.links.web.url ) {
                        url = u.links.web.url;
                    }
                }
                return url;
            }
        },
        renderCell: {
            name: ( { row } ) => {
                return ( row.name ) ? <Link to={`/user/${row.email}`}>{row.name}</Link> : null
            },
            date: ( { value } ) => {
                let d;
                if ( value ) {
                    d = value.toLocaleDateString();
                }
                return d;
            },
            appUrl: ( { id } ) => {
                let url;
                const u = users[id];
                if ( u ) {
                    if ( u.links && u.links.app ) {
                        url = u.links.app;
                    }
                }
                return ( url ) ? <a href={`${url}`}>{url}</a> : null;
            },
            webUrl: ( { id } ) => {
                let url;
                const u = users[id];
                if ( u ) {
                    if ( u.links && u.links.web && u.links.web.url ) {
                        url = u.links.web.url;
                    }
                }
                return ( url ) ? <a href={`${url}`}>{url}</a> : null;
            }
        },
        valueFormatter: {
            date: ( { value } ) => {
                return ( value ) ? value.toLocaleDateString() : null;
            }
        },
        getApplyQuickFilterFn: {
            singleSelectQuickFilter: singleSelectQuickFilter
        }
    };

    const [ selectedRows, setSelectedRows ] = useState( [] );
    
    const handleSingleModal = ( t, cid ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'log-call':
                console.log( 'log-call w/ cid: ' + cid );
                setModal( <LogComms commType='Call' close={closeModal} cid={cid} /> );
                break;

            default:
                shouldOpen = false;
                console.log( 'unknown modeal type for single: ' + t + ' - ' + cid )  ;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const handleMassModal = async ( t ) => {
        let shouldOpen = true;

        let list = [];
        let cids = [];
        selectedRows.forEach( r => {
            console.log( r );
            const u = users[r];
        } );

        switch ( t ) {
            case 'email-mass':
                // setModal( <SendMassEmail contacts={ contacts } close={ closeModal } /> );
                shouldOpen = false;
                break;

            case 'sms-mass':
                // setModal( <SendTxt contacts={ contacts } close={ closeModal } /> ); 
                shouldOpen = false;
                break;
    
            case 'phoneburner':
                await launchPhoneBurner( aid, uid, cids, list, stack.dialer );
                shouldOpen = false;
                break;
        
            default:
                console.log( 'Unknown modal type: ' + t );
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const handleModal = ( t ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'email':
                setModal( <SendEmail /> );
                break;

            case 'sms':
                setModal( <SendTxt /> );
                break;

            case 'event':
                setModal( <AddEvent /> );
                break;

            default:
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
        
        console.log( 'modal: ' + t );
    }

    const getRowClassName = ( params ) => {
        let cn = '';
        // console.log( classLogic );
        if ( classLogic ) {
            eval( classLogic );
        }
        return cn;
    }

    useEffect( () => {
        document.title = 'Third Floor - Users';
    }, [] );
    
    useEffect( () => {
        let filters = {};
        for ( let [ key, value ] of query.entries() ) {
            filters[key] = value;
        }

        if ( grids && grids.users && !gridReady ) {
            let activeFilter = false;
            setFilterName( '' );
            
            let storedCols = JSON.parse( grids.users.cols );
            if ( filters.fn && grids.users.filters && grids.users.filters[filters.fn] ) {
                if ( grids.users.filters[filters.fn].cols ) {
                    activeFilter = true;
                    setUsingFilter( true );
                    setFilterName( filters.fn );
                    storedCols = JSON.parse( grids.users.filters[filters.fn].cols );
                }

                if ( grids.users.filters[filters.fn].criteria ) {
                    const crit = JSON.parse( grids.users.filters[filters.fn].criteria );
                    setFilterModel( { items: crit } );
                }

                if ( grids.users.filters[filters.fn].className ) {
                    setClassLogic( grids.users.filters[filters.fn].className );
                }
            } else {
                if ( filters.crit ) {
                    const crit = JSON.parse( filters.crit );
                    setFilterModel( { items: crit } );
                }
                if ( grids.users.className ) {
                    setClassLogic( grids.users.className );
                }
            }

            if ( storedCols ) {
                let cols = storedCols.map( c => {
                    if ( c.renderCell && gridHelpers.renderCell[c.renderCell] ) {
                        c.renderCell = gridHelpers.renderCell[c.renderCell];
                    }
                    if ( c.valueGetter && gridHelpers.valueGetter[c.valueGetter] ) {
                        c.valueGetter = gridHelpers.valueGetter[c.valueGetter];
                    }
                    if ( c.valueFormatter && gridHelpers.valueFormatter[c.valueFormatter] ) {
                        c.valueFormatter = gridHelpers.valueFormatter[c.valueFormatter];
                    }
                    if ( c.getApplyQuickFilterFn && gridHelpers.getApplyQuickFilterFn[c.getApplyQuickFilterFn] ) {
                        c.getApplyQuickFilterFn = gridHelpers.getApplyQuickFilterFn[c.getApplyQuickFilterFn];
                    }

                    if ( user && user.datagrids && user.datagrids.users ) {
                        if ( activeFilter ) {
                            if ( user.datagrids.users.filters && user.datagrids.users.filters[filters.fn] && user.datagrids.users.filters[filters.fn].colSize && user.datagrids.users.filters[filters.fn].colSize[c.field] ) {
                                c.width = user.datagrids.users.filters[filters.fn].colSize[c.field];
                            }
                        } else if ( user.datagrids.users.colSize && user.datagrids.users.colSize[c.field] ) {
                            c.width = user.datagrids.users.colSize[c.field];
                        }
                    }

                    return c;
                } );

                if ( user && user.datagrids && user.datagrids.users ) {
                    if ( activeFilter ) {
                        if ( user.datagrids.users.filters && user.datagrids.users.filters[filters.fn] && user.datagrids.users.filters[filters.fn].colOrder && user.datagrids.users.filters[filters.fn].colOrder.length ) {
                            cols = user.datagrids.users.filters[filters.fn].colOrder.map( field => {
                                return storedCols.find( f => f.field === field );
                            } );
                        }
                    } else {
                        if ( user.datagrids.users.colOrder && user.datagrids.users.colOrder.length ) {
                            cols = user.datagrids.users.colOrder.map( field => {
                                return storedCols.find( f => f.field === field );
                            } );
                        }
                    }
                }

                setCols( cols );
                setGridReady( true );
            }
        }
    }, [ user, grids, gridHelpers.renderCell, gridHelpers.valueGetter, gridHelpers.valueFormatter, gridHelpers.getApplyQuickFilterFn, gridReady, query, rowModesModel ] );
    
    useEffect(() => {
        if ( location.search !== q ) {
            setGridReady( false );
            setFilterModel( { items: [] } );
            setClassLogic( '' );
            setQ( location.search );
        }
    }, [ location.search, q ] ); 
    
    useEffect( () => {
        if ( user.additionalAccounts && user.additionalAccounts.length > 1 ) {
            setContainerBuffer( prev => prev + 30 );
        }
    }, [ user.additionalAccounts ] );

    useEffect( () => {
        setGridHeight( containerRef.current.clientHeight - titleRef.current.clientHeight - 15 );
    }, [ containerBuffer ] );

    useEffect( () => {
        console.log( 'admin users: ', users );
        if ( users ) {
            let list = [];
            Object.keys( users ).forEach( uid => {
                const u = users[uid];
                
                list.push( {
                    ...u
                } );
            } );
            setUsers( list );
            setLoading( false );
        }
    }, [ users ] );

    useEffect( () => {
        if ( stack ) {
            if ( stack.dialer && stack.dialer.type === 'PhoneBurner' ) {
                setHasPhoneBurner( true );
            }
            if ( stack.sms && stack.sms ) {
                setHasTxting( true );
            }
        }
    }, [ stack ] );

    return (
        <Container fluid className='px-0' style={ { height: '100%' } }>
            <Row className='tf-page-container' style={ { height: `calc(100vh - ${containerBuffer}px)` } } ref={containerRef}>
                <Col className='p-0' style={ { height: '100%' } }>
                    <Card style={ { height: '100%' } }>
                        <Card.Body className='py-0'>
                            <Card.Title className='pt-1' ref={titleRef}>
                                <Row>
                                    <Col>
                                        <VscFolderActive />
                                        <span className='ps-2 fw-bold fs-6'>System Users</span>
                                    </Col>
                                </Row>
                            </Card.Title>
                            <Row>
                                <Col style={ { display: 'flex', height: `${gridHeight}px`, width: '100%' } }>
                                    <ListsModal.Provider value={ { openModal, closeModal, setModal } }>
                                        <DataGridPro
                                            apiRef={gridRef}
                                            initialState={ { 
                                                pinnedColumns: { 
                                                    left: [ GRID_CHECKBOX_SELECTION_COL_DEF.field, 'name' ]
                                                }
                                            } }
                                            getRowId={ ( row ) => row.email }
                                            loading={ loading }
                                            rows={uList}
                                            columns={cols}
                                            density='compact'
                                            checkboxSelection
                                            disableSelectionOnClick
                                            slots={ { 
                                                toolbar: toolbar,
                                                columnMenu: customColumnMenu 
                                            } }
                                            slotProps={ { toolbar: {
                                                selectedRows: selectedRows, 
                                                handleModal: handleModal, 
                                                hasTxting: hasTxting, 
                                                hasPhoneBurner: hasPhoneBurner, 
                                                canExport: canExport
                                            } } }
                                            onRowSelectionModelChange={ ( ids ) => setSelectedRows( ids ) }
                                            filterModel={ filterModel }
                                            onFilterModelChange={ ( newFilterModel ) => setFilterModel( newFilterModel ) }
                                            getRowClassName={ getRowClassName }
                                            getRowHeight={ () => 'auto' }
                                            onColumnWidthChange={ handleColumnWidthChange }
                                            onColumnOrderChange={ handleColumnOrderChange }
                                        />
                                    </ListsModal.Provider>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ToastContainer autoClose={3000} />
            <Modal show={show} onHide={closeModal} centered size='lg'>
                {modal}
            </Modal>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    orgId: state.user.orgId,
    aid: state.user.aid,
    uid: state.user.email,
    user: state.user,
    grids: state.user.meta.datagrids,
    viewing: state.user.viewing,
    canExport: state.user.canExport,
    stack: state.user.stack,
    users: state.admin.byId,
} );
  
const mapDispatch = ( dispatch ) => ( {
    setDatagridWidth: dispatch.user.setDatagridWidth,
    setDatagridOrder: dispatch.user.setDatagridOrder
} );
  
export default connect( mapProps, mapDispatch )( Users );